
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Forceurbaniaonrentnpune() {



  const cardData =
  {
    keyword: ' Force Urbania on Rent in Pune',
    heading: 'Vaishnavi Travels: Force Urbania on Rent in Pune',
    headingDescription: 'Vaishnavi Travels provides affordable and reliable Force Urbania on Rent in Pune, perfect for family trips, corporate outings, weddings, school tours, and long-distance journeys. Our Force Urbania is well-maintained with spacious seating, modern interiors, strong air-conditioning, and ample luggage space, ensuring a comfortable and enjoyable ride for every passenger. With professional drivers, punctual pickups, and flexible booking options, we make group travel simple and stress-free. Whether it’s a local city ride, religious yatra, or outstation tour, Vaishnavi Travels guarantees safe, convenient, and comfortable Force Urbania rental services in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace and a proud symbol of Maratha power. Once the seat of the Maratha Empire, its massive gates, sprawling gardens, and ruins narrate tales of valor. Though partially destroyed by a fire in 1828, it still draws thousands of visitors every day. The evening light-and-sound show brings alive the love story of Bajirao and Mastani and the grandeur of the Peshwas. Its corridors, courtyards, and fountains carry echoes of Maratha history. Shaniwar Wada remains Pune’s most cherished cultural landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892, the Aga Khan Palace is one of Pune’s most historic monuments linked to India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, the palace houses a museum displaying Gandhi’s personal belongings, letters, and photographs. Its Italian arches and sprawling gardens add architectural charm and peaceful vibes. Tourists enjoy strolling through its lawns while reflecting on history. Aga Khan Palace is Pune’s inspirational symbol of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is a legendary hill fort known for the 1670 battle where Tanaji Malusare fought valiantly for Chhatrapati Shivaji Maharaj. Perched atop a hill, it offers breathtaking panoramic views of the Sahyadris and trekking trails loved by adventurers. The fort still houses bastions, memorials, and temples that narrate Maratha bravery. During monsoon, mist and waterfalls enhance its charm. Visitors also relish rustic delicacies like pithla-bhakri at local stalls. Sinhagad Fort is Pune’s perfect blend of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. Established over 125 years ago, it houses a magnificent idol adorned with gold and ornaments. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities attracting lakhs of devotees. Known for its charitable and cultural initiatives, it serves as both a spiritual and social hub. The temple’s vibrant aura captivates tourists and locals alike. Dagdusheth Ganpati Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, sanctum chambers, and a Nandi mandapa. Despite being in the city center, it offers peace and meditation amidst the chaos. Evening prayers and chants add to its mystical ambiance. The temple reflects ancient Indian craftsmanship and architectural skill. Pataleshwar Cave Temple is Pune’s hidden gem of spiritual heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include musical instruments, ornaments, sculptures, and everyday antiques. A highlight is the recreated Mastani Mahal, reflecting the romance of Maratha history. Students and history enthusiasts find it deeply educational and fascinating. The museum preserves centuries of traditions and artistry under one roof. Raja Dinkar Kelkar Museum is Pune’s proud showcase of culture and heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage landmarks, offers panoramic views of the city from its temple complex. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller temples and a museum add depth to the visit. Pilgrims and tourists climb 103 steps to reach the top, combining devotion with scenic beauty. Sunrise and sunset views from here are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for wellness, spirituality, and mindfulness. Spread across lush gardens, it attracts seekers and tourists from all over the world. The ashram offers meditation sessions, yoga practices, and personal growth workshops. Its Japanese Zen gardens and tranquil halls enhance the experience. Beyond spirituality, it is also a retreat for relaxation and rejuvenation. Osho Ashram is Pune’s international center of peace and healing."
  },
  {
    "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With flowing streams, stone bridges, and manicured lawns, it is a paradise for nature lovers. Families enjoy picnics, photography, and peaceful walks here. The garden symbolizes Indo-Japanese friendship and cultural exchange. Seasonal flowers add color and charm throughout the year. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is Pune’s popular weekend getaway. It supplies water to the city while offering scenic backdrops of hills and flowing waters. During monsoon, the overflowing dam creates spectacular views. Families enjoy roadside snacks like roasted corn and tea by the banks. It also serves as the gateway to Sinhagad Fort nearby. Khadakwasla Dam is Pune’s refreshing natural retreat for relaxation and leisure."
  }
],

"services": [
  {
    "name": "Urbania Bus Hire Pune",
    "description": "Urbania bus hire services in Pune offer a perfect blend of comfort and style for small to mid-sized group travel. Whether you're planning a family tour, business event, or airport transfer, our Urbania vans ensure a smooth ride with well-maintained interiors, reliable AC, and modern safety features. Each vehicle is driven by trained professionals to guarantee punctuality and travel convenience across local and outstation routes."
  },
  {
    "name": "13/17 Seater Urbania Van Pune",
    "description": "Book 13 or 17-seater Force Urbania vans in Pune for premium group transport. These mid-size vans are ideal for city sightseeing, religious tours, family functions, or official travel. Each Urbania is equipped with plush seating, overhead storage, ambient lighting, and climate control. Choose this seating configuration for maximum comfort and optimum space utilization when traveling with your team or loved ones."
  },
  {
    "name": "Force Urbania with Driver",
    "description": "Hire Force Urbania vans in Pune complete with professional, uniformed drivers who are experienced in local and outstation routes. The service includes driver allowances, fuel options, and flexible scheduling. Ideal for delegations, executive tours, or family trips, our drivers prioritize safety and courtesy, making sure your group gets the best travel experience possible with every ride."
  },
  {
    "name": "AC Urbania Rental Pune",
    "description": "Travel in absolute comfort with our AC Urbania rentals in Pune. These air-conditioned vans feature advanced cooling systems, comfortable seats, tinted windows, and smooth suspension—perfect for all-day travel or long-distance journeys. Recommended for summer events, airport pick-ups, and family vacations, AC Urbania ensures a refreshing ride for all passengers regardless of weather or traffic."
  },
  {
    "name": "Non AC Urbania Hire Pune",
    "description": "Our Non-AC Urbania hire service in Pune offers an economical and efficient travel option for short-distance or budget group trips. These well-maintained vehicles are ideal for school tours, wedding guest movements, or team transfers within city limits. Despite the absence of air conditioning, comfort is not compromised thanks to ventilated windows, cushioned seats, and experienced drivers."
  },
  {
    "name": "Outstation Urbania Rental Service",
    "description": "Plan your outstation group travel from Pune with our dedicated Urbania rental service. Ideal for weekend getaways, religious tours, hill station visits, or corporate retreats, these vans are built for endurance and comfort. With high mileage, strong suspension, and trained drivers, your group enjoys seamless intercity travel across Maharashtra and neighboring states. Optional services include overnight trips, multi-city itineraries, and luggage support."
  },
  {
    "name": "Urbania Wedding Transport Pune",
    "description": "Make your wedding transportation elegant and organized with our Urbania vans in Pune. Perfect for ferrying bride or groom’s family, special guests, or even the couple, these vehicles offer luxurious seating, ample legroom, and customization options like decorations or signage. Available for hourly, full-day, or multi-day rentals, our wedding-focused Urbania vans help ensure your guests arrive in comfort and style."
  },
  {
    "name": "Urbania for Tour Travel Pune",
    "description": "Explore top tourist destinations from Pune in a Force Urbania, tailored for small group tour travel. These vehicles are great for visiting spots like Lonavala, Mahabaleshwar, Shirdi, or Goa. With cushioned seats, wide windows, and optional entertainment systems, travel becomes an integral part of your holiday experience. Suitable for both domestic tourists and foreign visitors seeking a private, safe tour vehicle."
  },
  {
    "name": "Family Trip Urbania Pune",
    "description": "Book an Urbania van in Pune for your next family outing or celebration. Whether it’s a birthday, family reunion, or pilgrimage, the Urbania provides spacious and comfortable travel for up to 17 passengers. Features like mobile charging ports, headrests, and extra luggage space make this vehicle ideal for families who love to travel together without compromising comfort."
  },
  {
    "name": "Urbania for Corporate Travel",
    "description": "Our Force Urbania vans are perfect for corporate travel requirements in Pune—be it airport transfers, business site visits, or client pick-ups. Vans offer plush interiors, professional aesthetics, and discreet drivers trained in executive transport etiquette. Get GST-compliant billing, on-time performance, and real-time vehicle tracking to ensure your business travel is managed seamlessly and professionally."
  },
  {
    "name": "Premium Urbania Service Pune",
    "description": "Upgrade your travel experience with our premium Urbania van services in Pune. Featuring leather seats, ambient lighting, surround sound systems, and customizable interiors, these vans cater to VIPs, high-end events, or luxury group transport. Whether you're hosting a celebrity, arranging a high-profile wedding, or planning a luxury tour, our top-tier Urbania vans deliver unparalleled travel comfort and prestige."
  },
  {
    "name": "Urbania Booking Online Pune",
    "description": "Book your Urbania van online in Pune through our easy-to-use platform. Compare models, check seating capacity, view features, and receive instant confirmations. Options include both AC and Non-AC, driver-inclusive packages, and custom rental durations. Enjoy a seamless, digital booking experience for your next family trip, event, or outstation travel—24/7 support and transparent pricing guaranteed."
  },
  {
    "name": "Event Urbania Rental Pune",
    "description": "Simplify group logistics for private and corporate events with Urbania van rentals in Pune. Whether it’s a seminar, product launch, musical event, or birthday party, these vans ensure hassle-free transport of staff, VIPs, or guests. Available with hourly or full-day packages, event-focused services include location coordination, route mapping, and optional branding on vehicle exteriors."
  }
],
"tableData": [
  ["Urbania Bus Hire Pune", "13/17 Seater Urbania Van Pune"],
  ["Force Urbania with Driver", "AC Urbania Rental Pune"],
  ["Non AC Urbania Hire Pune", "Outstation Urbania Rental Service"],
  ["Urbania Wedding Transport Pune", "Urbania for Tour Travel Pune"],
  ["Family Trip Urbania Pune", "Urbania for Corporate Travel"],
  ["Premium Urbania Service Pune", "Urbania Booking Online Pune"],
  ["Event Urbania Rental Pune"]
],




"whychoose": [
  {
    "WhyChooseheading": "Force Urbania on Rent in Pune at Best Price",
    "WhyChoosedescription": "Vaishnavi Travels offers top-quality Force Urbania rental services in Pune, ideal for luxury group travel, corporate transfers, and special occasions."
  },
  {
    "WhyChooseheading": "Comfortable and Modern Interiors",
    "WhyChoosedescription": "Our Force Urbania vans come with plush seating, air conditioning, individual lighting, and premium interiors for a smooth and stylish ride."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "All Urbania vehicles are regularly serviced and deep-cleaned before every trip to ensure maximum comfort, safety, and hygiene."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental plans based on your travel needs — perfect for short trips or long-distance journeys."
  },
  {
    "WhyChooseheading": "Professional and Courteous Chauffeurs",
    "WhyChoosedescription": "Our experienced drivers ensure a smooth, safe, and pleasant travel experience across Pune and outstation routes."
  },
  {
    "WhyChooseheading": "All-Inclusive and Transparent Pricing",
    "WhyChoosedescription": "No hidden fees — our rental charges include fuel, tolls, driver allowance, and taxes for a worry-free experience."
  },
  {
    "WhyChooseheading": "Ideal for Luxury Travel, Airport Transfers, and Events",
    "WhyChoosedescription": "Force Urbania is perfect for executive travel, airport pick-ups, weddings, leisure tours, and group events in and around Pune."
  },
  {
    "WhyChooseheading": "24/7 Support and Easy Booking",
    "WhyChoosedescription": "Our customer support team is available 24/7 to assist with bookings, rescheduling, and route planning."
  }
]
















  }







const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer Force Urbania on rent in Pune?',
      answer: 'Yes, Vaishnavi Travels provides Force Urbania vehicles on rent in Pune, suitable for comfortable group travel, corporate use, and special occasions.',
    },
    {
      question: 'What is the seating capacity of the Force Urbania available for rent?',
      answer: 'Our Force Urbania vehicles typically accommodate 9 to 12 passengers, offering spacious seating and ample legroom.',
    },
    {
      question: 'Are Force Urbania vehicles air-conditioned and well-maintained?',
      answer: 'Absolutely! All Force Urbania vehicles in our fleet are fully air-conditioned, regularly serviced, and maintained to ensure safety and comfort.',
    },
    {
      question: 'What is the approximate rental cost for Force Urbania in Pune?',
      answer: 'Rental prices start at around ₹3,000 for half-day local trips. Exact pricing depends on duration, distance, and specific requirements.',
    },
    {
      question: 'Are professional drivers included with the rental?',
      answer: 'Yes, all rentals come with experienced and courteous drivers dedicated to providing a safe and pleasant journey.',
    },
    {
      question: 'Can I hire Force Urbania for outstation trips from Pune?',
      answer: 'Yes, we offer outstation packages including day trips and multi-day journeys with transparent pricing and service assurance.',
    },
    {
      question: 'How far in advance should I book Force Urbania?',
      answer: 'It is recommended to book at least 2-3 days in advance, especially during weekends and peak travel seasons.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Rahul Joshi",
    position: "Corporate Client",
    feedback:
      "Vaishnavi Travels provided a Force Urbania for our business trip. The vehicle was clean and comfortable, and the driver was punctual and professional. Great experience overall.",
    rating: 5,
  },
  {
    name: "Ms. Anjali Deshmukh",
    position: "Family Organizer",
    feedback:
      "We rented a Force Urbania for a family outing. The vehicle was spacious, AC worked perfectly, and the driver was very courteous. Highly recommended service by Vaishnavi Travels.",
    rating: 5,
    style: "style-2",
  }
];





























































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Force Urbania on Rent in Pune",
  "image": "https://vaishnavitravel.com/assets/images/force-urbania-rental-pune.jpg",
  "description": "Book Force Urbania on rent in Pune with Vaishnavi Travels. Choose from 13 or 17 seater AC/Non AC Urbania vans for weddings, corporate travel, family trips, or outstation journeys with driver.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.82",
    "ratingCount": "690"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4200",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/force-urbania-on-rent-in-pune"
  }
};



  return (
    <div>

<Helmet>
  <title>Force Urbania on Rent in Pune | 13 & 17 Seater AC/Non AC Vans | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book Force Urbania on rent in Pune with Vaishnavi Travels. Choose from 13 or 17 seater AC/Non AC Urbania vans for weddings, corporate travel, family trips, or outstation journeys with driver."
  />
  <meta
    name="keywords"
    content="Urbania Bus Hire Pune, 13/17 Seater Urbania Van Pune, Force Urbania with Driver, AC Urbania Rental Pune, Non AC Urbania Hire Pune, Outstation Urbania Rental Service, Urbania Wedding Transport Pune, Urbania for Tour Travel Pune, Family Trip Urbania Pune, Urbania for Corporate Travel, Premium Urbania Service Pune, Urbania Booking Online Pune, Event Urbania Rental Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/34.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Forceurbaniaonrentnpune;